import React, { memo, useState } from 'react'
import cn, { Argument as ClassName } from 'classnames'

import { WidgetLayout } from '../../../lib/widget-layout'
import Text from '../../../ui/Text'
import { ChargePointUser } from '../../../common/redux/api/web-api'
import { Table, TableBody, TableBodyCell, TableHeader, TableHeaderCell, TableRow } from '../../../lib/table'
import { ChargersPagination } from '../../../lib/chargers-pagination'
import { Button } from '../../../common/components/Button'
import useText from '../../../common/hooks/useText'

export type CompanyUsersWidgetProps = {
    className?: ClassName
    style?: React.CSSProperties
    openUserModal: () => void
    users: ChargePointUser[]
    removeUser: (user: ChargePointUser) => void
}

export const CompanyUsersWidget = memo(function CompanyUsersWidget({
    className,
    style,
    openUserModal,
    users,
    removeUser,
}: CompanyUsersWidgetProps): React.ReactElement {
    const text = useText()
    const [currentPage, setCurrentPage] = useState(0)
    const [pageSize] = useState(20)
    const offset = currentPage * pageSize

    const handlePageClick = (selected: number) => {
        setCurrentPage(selected)
    }
    return (
        <WidgetLayout
            data-testid="table-users"
            className={cn(className)}
            style={style}
            title={<Text code="lblUsersWidget" />}
            headerButtons={[
                <Button data-testid="table-users-add-btn" onClick={() => openUserModal()} type="button" size="sm">
                    {text('btnAdd')}
                </Button>,
            ]}
        >
            <Table>
                <TableHeader>
                    <TableRow>
                        <TableHeaderCell data-testid="table-username-heading">
                            <Text code="lblName"></Text>
                        </TableHeaderCell>
                        <TableHeaderCell data-testid="table-useredit-heading">
                            <Text code="lblRole"></Text>
                        </TableHeaderCell>
                        <TableHeaderCell data-testid="table-userremove-heading">
                            <Text code="lblRemove"></Text>
                        </TableHeaderCell>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {users?.slice(offset, offset + pageSize).map((user) => (
                        <TableRow key={user?.id}>
                            <TableBodyCell data-testid="table-username-body">
                                {user.firstName}
                                {''} {user.lastName}
                            </TableBodyCell>
                            <TableBodyCell data-testid="table-userrole-body">{user.roleInCompany}</TableBodyCell>

                            <TableBodyCell data-testid="table-userremoveBtn-body">
                                <button
                                    type="button"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="Remove"
                                    onClick={() => removeUser(user)}
                                    className="btn btn-danger btn-xs btn-icon"
                                    data-testid="table-userbtn-remove"
                                >
                                    <span className="fa fa-remove"></span>
                                </button>
                            </TableBodyCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>

            {users?.length > 20 && (
                <ChargersPagination
                    setPageIndex={handlePageClick}
                    totalCount={users.length}
                    pageSize={pageSize}
                    pageIndex={currentPage}
                    displayedChargers={pageSize}
                />
            )}
            {!users && <div className="shimmer-container shimmer-xsmall" data-testid="user-loading"></div>}
        </WidgetLayout>
    )
})
